import React from 'react';
import '../App.css';
import Header from './Header';

function Demo() {
    return (
        <div className="demo-page">
            <Header />
            <div className="main-content">
                <h1>Schedule a Demo</h1>
                <div className="meetings-iframe-container" data-src="https://meetings.hubspot.com/david4497?embed=true"></div>
                <script type="text/javascript" src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"></script>
            </div>
        </div>
    );
}

export default Demo;
